import React, { useEffect, useState } from "react";
import Style from "../style/bloglanding.module.scss";
import { useAppDispatch, useAppSelector } from "../redux/hooks";
import { fetchSingleBlog } from "../redux/Slice";
import Loader from "../Loader/Loader";
import BlogLandingLeft from "./BlogLandingLeft";
import { useParams } from "react-router-dom";
import BlogLandingRight from "./BlogLandingRight";

const BlogLanding = () => {
  const { userTitle } = useParams();
  const dispatch = useAppDispatch();
  const data = useAppSelector((state) => state.detail);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (userTitle) {
      setLoading(true);
      dispatch(fetchSingleBlog({ slug: userTitle })).finally(() =>
        setLoading(false)
      );
    }
  }, [dispatch, userTitle]);

  const {
    details,
    recent_blogs = [],
    categories = [],
  } = data?.singleblog?.data || {};

  return (
    <div className={Style.container}>
      {loading ? (
        <div className={Style.loader}>
          <Loader />
        </div>
      ) : (
        <>
          <div className={Style.blogGround}>
            <div className={Style.wrapper}>
              <div className={Style.breadcrumb}>
                <a href="/">Home</a>
                <span> › </span>
                <a href="/blog">Blog</a>
                {details?.title && (
                  <>
                    <span> › </span>
                    <span>{details.title}</span>
                  </>
                )}
              </div>
              <div className={Style.title}>
                <h2>{details?.title || "No blog found"}</h2>
              </div>
            </div>
          </div>
          <div className={Style.wrapper}>
            <div className={Style.divide}>
              <BlogLandingLeft
                details={details}
                recent_blogs={recent_blogs}
                userTitle={userTitle}
              />
              <BlogLandingRight
                categories={categories}
                recent_blogs={recent_blogs}
                details={details}
              />
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default BlogLanding;
